import { createAction } from 'redux-actions';

export const REFRESH_MESSAGES = 'REFRESH_MESSAGES';
const refreshMessagesAction = createAction(REFRESH_MESSAGES);

export const refreshMessages = (contactId: number) =>
  refreshMessagesAction({
    args: {
      contactId,
    },
  });
